var map = {
	"./exhibition-0.png": 80239,
	"./exhibition-1.JPG": 25863,
	"./exhibition-2.JPG": 64440,
	"./exhibition-3.JPG": 59829,
	"./exhibition-4.MP4": 25634,
	"./exhibition-5.jpg": 22278
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24828;